import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = ["href"]

import { computed } from "vue";
import { err } from "@/utils";
import { useFirmwareStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadFirmwareButton',
  props: {
    small: { type: Boolean }
  },
  setup(__props: any) {



const firmware = useFirmwareStore();

const downloadButtonTooltip = computed(() => {
  if (firmware.downloadUrl == "") return err("Compile the firmware first");
  return "Download keyboard firmware";
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip",
    "data-tip": downloadButtonTooltip.value
  }, [
    _createElementVNode("a", {
      href: _unref(firmware).downloadUrl ?? '',
      class: _normalizeClass(["btn btn-accent w-full join-item", [
        _unref(firmware).downloadUrl == null ? 'btn-disabled' : '',
        _ctx.small ? '' : 'min-w-[10rem]',
      ]])
    }, [
      _createVNode(_component_Icon, {
        icon: "ic:baseline-download",
        class: "mr-2 text-lg"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.small ? "" : "Download"), 1)
    ], 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})